export const appBaseURL = "/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"},{"name":"description","content":"Cocco Meet video chat with new people online ✔️ 1v1 chats ✔️online games✔️ support your favorite streamers ✔️make new friends"},{"name":"keywords","content":"Live Chat, meet new people, 1v1 video calls, online chatrooms, free video chat, webcam chat, random video chat, private video chat, cocco, Cocco，online games，gifts，entertainment，social"},{"property":"og:title","content":"Cocco - Meet new people and start wonderful entertainment game and chat"},{"property":"og:description","content":"Cocco Meet video chat with new people online ✔️ 1v1 chats ✔️online games✔️ support your favorite streamers ✔️make new friends"},{"property":"og:locale","content":"en"},{"property":"og:type","content":"website"},{"property":"og:site_name","content":"Cocco"},{"property":"og:url","content":"https://cocco.beta-h5.wooyavip.com"},{"property":"og:image","content":"https://h5.coccolive.com/logo.png"},{"property":"og:image:width","content":"180"},{"property":"og:image:height","content":"180"},{"property":"og:image:type","content":"image/png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"build-version","content":"test-v1.0.0"}],"link":[],"style":[],"script":[{"src":"https://cocco.beta-h5.wooyavip.com/cdn/js/lib-flexible@0.3.2.js"},{"type":"application/ld+json","children":"{\"@context\" : \"https://schema.org\", \"@type\" : \"WebSite\", \"name\" : \"Cocco\", \"url\" : \"https://cocco.beta-h5.wooyavip.com\"}"},{"src":"/cdn/js/lib-flexible@0.3.2.js"},{"src":"/cdn/js/AgoraRTC_N-4.19.3.js","defer":true},{"src":"/cdn/js/trtc-sdk-v5@5.9.0.js","defer":true},{"src":"/cdn/js/NIM_Web_NIM_v9.20.12.js","defer":true},{"src":"/cdn/js/svgaplayerweb@2.3.2.min.js","defer":true}],"noscript":[],"title":"Cocco - Meet new people and start wonderful entertainment game and chat"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false